import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
// import VisitorSetup from "SchoolSetup/routes/VisitorSetup";
// import CasExternalSupervisorSetup from "SchoolSetup/routes/CasExternalSupervisorSetup";
import PortfolioSetup from "Administrator/routes/Settings/routes/PortfolioManager/routes/PortfolioSetup";
import ActivitySettings from "Administrator/routes/Settings/routes/PortfolioManager/routes/ActivitySettings";
import PortfolioSettings from "Administrator/routes/Settings/routes/PortfolioManager/routes/Settings";
import PortfolioReviewSetup from "Administrator/routes/Settings/routes/PortfolioManager/routes/ReviewerSetup";
import RoleSetup from "Administrator/routes/Settings/routes/ProjectSettings/routes/RoleSetup";
import ProjectSetup from "Administrator/routes/Settings/routes/ProjectSettings/routes/ProjectSetup";
import SettingsV2 from "Administrator/routes/Settings/routes/SettingsV2";
import {
  AnnouncementsReviewerSetupRoute,
  AnnouncementSettingsRoute,
} from "./routes";
import ServiceActivityReflectionQuestions from "Administrator/routes/Settings/routes/ProjectSettings/routes/ServiceActivityReflectionQuestions";

export default store => ({
  path: "settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "grade-levels" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [
    PortfolioSetup(store),
    ActivitySettings(store),
    PortfolioSettings(store),
    PortfolioReviewSetup(store),
    AnnouncementsReviewerSetupRoute(store),
    AnnouncementSettingsRoute(store),
    RoleSetup(store),
    ProjectSetup(store),
    ServiceActivityReflectionQuestions(store),
    SettingsV2(store),
  ],
});
